
import type React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux'
import { OpenFeatureProvider } from '@openfeature/react-sdk';

import SideBarView from './SideBarView';
import TopBarView from './TopBarView';
import MainBarView from './MainBarView';

import AccountSwitchView from '../accountSwitch/AccountSwitchView';

import { confirmAlert } from 'react-confirm-alert';
import ModalSpinner from '../../components/spinner/modalSpinner.js';
import ModalForm from '../../components/modalForm/modalForm.js';
import AttachmentForm from '../../components/attachment/attachmentForm.js';
import AlertContainer from '../../components/alert/alertContainer.js';
import ImageUpload from '../../components/imageUpload/ImageUpload.jsx';
import ValidationModal from '../modules/menus/menu/common/validation/validationModal.jsx';
import { initializeOpenFeature } from '../../utils/featureFlags/openFeature';

var viewUtil = require('../../utils/view/viewUtil.js');
const logger = require('../../utils/logger/logger');

interface Franchisor {
    code: string;
}

interface ConfirmDialogue {
    title: string;
    message: string;
    onConfirm?: () => void;
    onCancel?: () => void;
}

interface ModalFormData {
    componentCreator: (() => React.ReactNode) | null;
}

interface AttachmentFormData {
    objectType: string | null;
    objectId: string | null;
}

interface ImageUploadDialogue {
    isOpen: boolean;
}

interface ContainerViewProps {
    franchisors: Franchisor[];
    displayAccountSwitchScreen: boolean;
    confirmDialogue: ConfirmDialogue | null;
    modalForms: ModalFormData[];
    attachmentForm: AttachmentFormData | null;
    imageUploadDialogue: ImageUploadDialogue | null;
}

class ContainerView extends Component<ContainerViewProps> 
{
    constructor(props: ContainerViewProps) 
    {
        super(props);
    }

    async componentDidMount() 
    {

        console.log('ContainerView componentDidMount', this.props);
        
        // Initialize OpenFeature with user context for targeting
        if (this.props.franchisors?.length > 0) {
            const targetingKey = this.props.franchisors[0].code;
            console.log('targetingKey:', targetingKey);
            await initializeOpenFeature({ targetingKey });
            logger.attachOrgToGlobalContext();

        } 
    }

    render()
    {
        this.showConfirmationDialogue();

        return (
            <OpenFeatureProvider>
                <div style={{ width: "100%" }}>
                    <div className='d-flex flex-column' style={{ width: "100%", height: '100%' }}>
                        <TopBarView />
                        <div className='d-flex flex-row' style={{ flex: 1, height: 0 }}>
                            <div style={{ whiteSpace: "nowrap", verticalAlign: "top", padding: "0px" }}>
                                <SideBarView />
                            </div>
                            <div style={{ verticalAlign: "top", padding: "0px", flex: 1, overflow: 'auto', height: '100%' }}><MainBarView /></div>
                        </div>
                    </div>
                    {this.renderAccountSwitchScreen()}
                    <AlertContainer />
                    <ModalSpinner />
                    {this.showModalForm()}
                    {this.showAttachmentForm()}
                    {this.showImageUploadDialogue()}
                </div>
            </OpenFeatureProvider>
        );
    }

    renderAccountSwitchScreen()
    {
        if (!this.props.displayAccountSwitchScreen)
            return null;

        return <AccountSwitchView />
    }


    showConfirmationDialogue()
    {
        if (this.props.confirmDialogue == null)
            return;

        var confirmOptions: any = {};
        confirmOptions.title = this.props.confirmDialogue.title;
        confirmOptions.message = this.props.confirmDialogue.message;
        confirmOptions.buttons = [
            {
                label: 'No',
                onClick: () =>
                {
                    viewUtil.closeConfirmDialogue();
                    this.props.confirmDialogue?.onCancel?.();
                }
            },
            {
                label: 'Yes',
                onClick: () =>
                {
                    viewUtil.closeConfirmDialogue();
                    this.props.confirmDialogue?.onConfirm?.();
                }
            }
        ];

        confirmOptions.afterClose = () => { viewUtil.closeConfirmDialogue(); };
        confirmOptions.overlayClassName = 'confirm-alert-overlay';
        confirmAlert(confirmOptions);
    }

    showImageUploadDialogue()
    {
        if (this.props.imageUploadDialogue == null)
            return;

        return <ImageUpload />
    }

    showModalForm()
    {
        var modalFormsComponents: React.ReactNode[] = [];

        var index = 0;
        this.props.modalForms.forEach(modalForm =>
        {
            if (modalForm != null && modalForm.componentCreator != null)
                modalFormsComponents.push(<ModalForm modalFormIndex={index}></ModalForm>);

            index = index + 1;
        })

        return modalFormsComponents;
    }

    showAttachmentForm()
    {

        if (this.props.attachmentForm == null || this.props.attachmentForm.objectType == null || this.props.attachmentForm.objectId == null)
            return;

        return (<AttachmentForm></AttachmentForm>);
    }
}

const mapStateToProps = (state: any) => 
{
    return {
        franchisors: state.orgData.organizationTaxonomy.franchisors,
        displayAccountSwitchScreen: state.displayAccountSwitchScreen,
        confirmDialogue: state.confirmDialogue,
        modalForms: state.modalForms,
        attachmentForm: state.attachmentForm,
        imageUploadDialogue: state.imageUploadDialogue,
    }
}

export default connect(mapStateToProps)(ContainerView)
